import js from "../assets/icons/icons8-javascript.gif";
import dev_amico from "../assets/images/Development-pana.png";
import react from "../assets/icons/icons8-react.gif";
import sql from "../assets/icons/icons8-postgresql-48.png";
import ruby from "../assets/icons/icons8-jewel-48.png";
import html from "../assets/icons/icons8-html.gif";
import css from "../assets/icons/icons8-css-filetype-40.png";
import bootstra from "../assets/icons/icons8-bootstrap-48.png";
import scss from "../assets/icons/icons8-sass-avatar-48.png";
import heroku from "../assets/icons/icons8-heroku-48.png";
import rails from "../assets/icons/icons8-rails.png";
import github from "../assets/icons/icons8-github.gif";

const skills = {
  photo: dev_amico,
  javascript: js,
  react: react,
  sql: sql,
  ruby: ruby,
  html: html,
  cs: css,
  bootstrap: bootstra,
  sass: scss,
  heroku: heroku,
  rails: rails,
  git: github,
};

export { skills };
